var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect, useCallback } from 'react';
import styled from '@emotion/styled';
import { boxShadow } from 'styled-system';
import { Grid } from '../../common/components/Grid';
import { CenterRightControls, CenterLeftControls, } from '../../common/components/LazyCarousel/Control';
import LazyCarousel from '../../common/components/LazyCarousel';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
import { ThemedMedia } from '../../common/components/Media';
import { HomepageTopTeaserSlide } from './HomepageTopTeaserSlide';
var HomepageTopTeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
HomepageTopTeaserGrid.defaultProps = {
    px: 0,
    pb: ['40px', 6, null, '56px'],
};
var CarouselContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: inherit;\n  ", ";\n"], ["\n  width: inherit;\n  ", ";\n"])), boxShadow);
CarouselContainer.defaultProps = {
    boxShadow: ['0 2px 6px 0 #c0c0c0', 'none'],
};
var HomepageTopTeaser = function (_a) {
    var items = _a.items;
    var _b = __read(useState(0), 2), activeSlide = _b[0], setActiveSlide = _b[1];
    useEffect(function () {
        var activeTopTeaserPromotion = {
            name: items[activeSlide].tracking.name,
            placement: items[activeSlide].tracking.placement,
            position: activeSlide,
        };
        dispatchTrackingEvent({
            event: 'promoView',
            eventAction: 'view',
            eventCategory: 'promotion',
            eventData: {
                promotions: [activeTopTeaserPromotion],
            },
        });
    }, [activeSlide, items]);
    var handleAfterSlide = useCallback(function (currentSlide) {
        setActiveSlide(currentSlide);
    }, [activeSlide]);
    var hasMultipleSlides = items.length > 1;
    var arrowProps = {
        arrowSize: '14px',
        controlShadow: 'none',
        size: '28px',
        mx: 2,
    };
    return (React.createElement(ThemedMedia, null, function (_a) {
        var desktop = _a.desktop;
        return (React.createElement(HomepageTopTeaserGrid, null,
            React.createElement(CarouselContainer, null,
                React.createElement(LazyCarousel, { showControlsOnHover: desktop, renderCenterLeftControls: function (props) { return (React.createElement(CenterLeftControls, __assign({}, arrowProps, props, { display: "flex" }))); }, renderCenterRightControls: function (props) { return (React.createElement(CenterRightControls, __assign({}, arrowProps, props, { display: "flex" }))); }, wrapAround: hasMultipleSlides, overflowHidden: true, afterSlide: handleAfterSlide }, items.map(function (item, index) { return (React.createElement(HomepageTopTeaserSlide, { key: "slide-" + index, item: item, index: index })); })))));
    }));
};
export default HomepageTopTeaser;
var templateObject_1, templateObject_2;
